import StayType from "models/StayType";
import { GenericService, Service } from "./genericService";

class StayTypeService
  extends GenericService<StayType>
  implements Service<StayType>
{
  constructor() {
    super("api/StayType");
  }
}

export default new StayTypeService();
